// ====================================================================== //
// Imports
// ====================================================================== //

import './helpers/custom-event-polyfill';
import 'jquery';

/* Globals */
import './helpers/polyfill';
import * as globals from './helpers/globals';

/* Typography */
import { ffoScript, loadFonts, loadFfoAsynchronously } from './modules/fonts-async';

/* Modules */
// import * as modules from './modules';
import header from './modules/header';
import './modules/youtube';
import gallery from './modules/gallery';
import quotes from './modules/quotes';
import projectsFilters from './modules/projects-filters';
import './modules/ie';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import picturefill from 'picturefill';
import './modules/satisfaction-form';
import './modules/satisfaction-confirmation';

/* Lazysizes */
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';

// ====================================================================== //
// Initializes
// ====================================================================== //

svg4everybody();

/* Typography */
loadFfoAsynchronously();
ffoScript.onload = loadFonts;

/* Lazysizes */
lazySizes.init();

/* Gallery of pictures */
gallery().init();

/* List of quotes */
quotes().init();

/* Filters for the projects page */
projectsFilters().init();

/* objectFitImages polyfill */
objectFitImages('.o-image-cover');
objectFitImages('.c-instagram__media');
picturefill();

// Fixed homepage header module
var navHeader = header();
globals.onReady.add(navHeader.init);
globals.onScroll.add(navHeader.onScroll, false);
globals.onResize.add(navHeader.onResize);

// ====================================================================== //
// Events
// ====================================================================== //

/* On ready */
document.addEventListener('DOMContentLoaded', globals.onReady.do);

/* On resize */
window.addEventListener('resize', globals.debounce(globals.onResize.do, 250));
